import { FLOW_STATES } from '@/modules/Flow/constants'

export const flowStates = [{
        name: FLOW_STATES.NEW,
        entryPointViewName: 'claim-landing'
    },
    {
        name: FLOW_STATES.CLAIM_DETAILS,
        entryPointViewName: 'claim-details'
    },
    {
        name: FLOW_STATES.PROCESSED,
        entryPointViewName: 'claim-closing'
    },
    {
        name: FLOW_STATES.PROCESSED_OK,
        entryPointViewName: 'claim-closing'
    },
    {
        name: FLOW_STATES.PROCESSED_KO,
        entryPointViewName: 'claim-closing'
    },
    {
        name: FLOW_STATES.PROCESSED_KO_BILLMA,
        entryPointViewName: 'claim-closing'
    },
    {
        name: FLOW_STATES.PROCESSED_ERROR,
        entryPointViewName: 'claim-closing'
    },
    {
        name: FLOW_STATES.WAITING_ROOM,
        entryPointViewName: 'claim-closing'
    },
    {
        name: FLOW_STATES.DAMAGES,
        entryPointViewName: 'damages-view'
    },
    {
        name: FLOW_STATES.GAG_DETAILS,
        entryPointViewName: 'damage-validation'
    },
    {
        name: FLOW_STATES.BILLMA,
        entryPointViewName: 'handle-document'
    },
    {
        name: FLOW_STATES.REN_DETAILS,
        entryPointViewName: 'add-appointment'
    },
    {
        name: FLOW_STATES.REN_DETAILS_RDF,
        entryPointViewName: 'add-appointment'
    },
    {
        name: FLOW_STATES.SMART,
        entryPointViewName: 'fnol-flow'
    },
    {
        name: FLOW_STATES.COMPENSATION_TYPE,
        entryPointViewName: 'claim-compensation-type'
    },
    {
        name: FLOW_STATES.COMPENSATION_MOBILIER,
        entryPointViewName: 'claim-compensation-mobilier'
    },
    {
        name: FLOW_STATES.COMPENSATION_MOBILIER_REN,
        entryPointViewName: 'claim-compensation-mobilier'
    },
    {
        name: FLOW_STATES.COMPENSATION_FRAIS,
        entryPointViewName: 'claim-compensation-frais'
    },
    {
        name: FLOW_STATES.COMPENSATION_MOBILIER_BILLMA,
        entryPointViewName: 'claim-compensation-mobilier'
    },
    {
        name: FLOW_STATES.COMPENSATION_FRAIS_BILLMA,
        entryPointViewName: 'claim-compensation-frais'
    },
    {
        name: FLOW_STATES.COMPENSATION_FRAIS_REN,
        entryPointViewName: 'claim-compensation-frais'
    },
    {
        name: FLOW_STATES.COMPENSATION_MOBILIER_PROCESSED_OK,
        entryPointViewName: 'claim-closing'
    },
    {
        name: FLOW_STATES.COMPENSATION_MOBILIER_PROCESSED_KO,
        entryPointViewName: 'claim-closing'
    },
    {
        name: FLOW_STATES.NEW_CONTACT,
        entryPointViewName: 'claim-closing'
    },
    {
        name: FLOW_STATES.MANUAL_REVIEW,
        entryPointViewName: 'claim-closing'
    },
    {
        name: FLOW_STATES.RDF_REN,
        entryPointViewName: 'claim-closing'
    },
    {
        name: FLOW_STATES.MANUAL_REVIEW_RDF,
        entryPointViewName: 'claim-closing'
    },
    {
        name: FLOW_STATES.GAG_RESUME,
        entryPointViewName: 'claim-summary'
    },
    {
        name: FLOW_STATES.REN_RESUME,
        entryPointViewName: 'claim-summary'
    },
    {
        name: FLOW_STATES.BILLMA_RESUME,
        entryPointViewName: 'claim-summary'
    },
    {
        name: FLOW_STATES.PROCESSED_ERROR_RDF,
        entryPointViewName: 'claim-closing'
    },
    {
        name: FLOW_STATES.PROCESSED_ERROR_BILLMA,
        entryPointViewName: 'claim-closing'
    },
    {
        name: FLOW_STATES.PROCESSED_ERROR_REN,
        entryPointViewName: 'claim-closing'
    },
    {
        name: FLOW_STATES.PROCESSED_KO_REN,
        entryPointViewName: 'claim-closing'
    },
    {
        name: FLOW_STATES.CALLBACK_REQUEST,
        entryPointViewName: 'claim-closing'
    },
    {
        name: FLOW_STATES.PROCESSED_KO_RDF,
        entryPointViewName: 'claim-closing'
    },
]